import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Typography, CircularProgress } from '@mui/material';
import { resumeService } from '../services/resume';
import ResumeInfo from '../components/resumes/ResumeInfo';
import Profile from '../components/resumes/Profile';
import EducationView from '../components/resumes/EducationView';
import ExperienceView from '../components/resumes/ExperienceView';
import SkillsView from '../components/resumes/SkillsView';

const ResumeDetail = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [resume, setResume] = useState(null);

  useEffect(() => {
    const fetchResumeData = async () => {
      try {
        const resumeData = await resumeService.getResume(id);
        setResume(resumeData);
      } catch (error) {
        console.error('Failed to fetch resume data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchResumeData();
  }, [id]);

  if (loading) {
    return (
      <Container sx={{ py: 4, textAlign: 'center' }}>
        <CircularProgress />
      </Container>
    );
  }

  if (!resume) {
    return (
      <Container sx={{ py: 4 }}>
        <Typography variant="h4" color="error">
          Resume not found
        </Typography>
      </Container>
    );
  }

  return (
    <Container sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        {resume.name}
      </Typography>
      {resume.description && (
        <Typography variant="subtitle1" color="text.secondary" gutterBottom>
          {resume.description}
        </Typography>
      )}

      <ResumeInfo resume={resume} />
      <Profile profile={resume.profile} />
      <ExperienceView experience={resume.experience} />
      <EducationView education={resume.education} />
      <SkillsView skills={resume.skills} />
    </Container>
  );
};

export default ResumeDetail; 